import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const CreateEmployeePageHeader = () => {
  const { t } = useTranslation()
  const handleBack = useBack()
  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />}>
        {t('components.pages.employees.create.pageHeader.back')}
      </Button>
      <PageHeader ghost={false} title={t('components.pages.employees.create.pageHeader.title')} />
    </Space>
  )
}

CreateEmployeePageHeader.displayName = 'CreateEmployeePageHeader'
export default CreateEmployeePageHeader
